export default {
  path: '/localisations',
  name: 'localisations',
  component: () => import('../components/localisation/Layout'),
  redirect: { name: 'LocalisationList' },
  children: [
    {
      name: 'LocalisationList',
      path: '',
      component: () => import('../views/localisation/List')
    },
    {
      name: 'LocalisationCreate',
      path: 'new',
      component: () => import('../views/localisation/Create')
    },
    {
      name: 'LocalisationUpdate',
      path: ':id/edit',
      component: () => import('../views/localisation/Update')
    },
    {
      name: 'LocalisationShow',
      path: ':id',
      component: () => import('../views/localisation/Show')
    }
  ]
};
